import React from "react";

/** The app's `ConfirmPayTopBar`: a back arrow over a 22px title. */
const ConfirmPayTopBar: React.FC<{
  title: string;
  onBack: () => void;
}> = ({ title, onBack }) => (
  <div className="shrink-0 px-4 pb-4 pt-5">
    <button type="button" onClick={onBack} aria-label="Back" className="block">
      <img
        src="/icons/listing/listing_page_back.svg"
        alt=""
        className="h-6 w-6"
      />
    </button>
    <h1 className="mt-5 text-22 font-semibold leading-7 text-ink">{title}</h1>
  </div>
);

export default ConfirmPayTopBar;
